module.exports = __webpack_public_path__ + "img/campaignpilot-campaign-other.3c3e485c.png";